import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import ShreeApp from '../components/shree/ShreeApp';

const ShreeLilaPage = () => {
  const navigate = useNavigate();

  return (
    <div className="shree-page">
      {/* Back Button */}
      {/* <button className="back-btn" onClick={() => navigate('/')}>
        <ArrowLeft size={14} />
        All Hotels
      </button> */}
      <ShreeApp />
    </div>
  );
};

export default ShreeLilaPage;
